import { render, staticRenderFns } from "./DataConfigurationErpColumnDropdown.vue?vue&type=template&id=609299ea&scoped=true"
import script from "./DataConfigurationErpColumnDropdown.vue?vue&type=script&lang=js"
export * from "./DataConfigurationErpColumnDropdown.vue?vue&type=script&lang=js"
import style0 from "./DataConfigurationErpColumnDropdown.scss?vue&type=style&index=0&id=609299ea&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609299ea",
  null
  
)

export default component.exports